import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateOnboarding} from '../api';
import {QUERY__ONBOARDING, QUERY__ONBOARDINGS} from '../queryKeys';
import {OnboardingType} from '../types';

export const useUpdateOnboarding = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({type, config}: {type: OnboardingType; config: string}) =>
      updateOnboarding(type, config),
    onSuccess: (_, {type}) => {
      void queryClient.invalidateQueries({queryKey: [QUERY__ONBOARDINGS]});
      void queryClient.invalidateQueries({
        queryKey: [QUERY__ONBOARDING, type],
      });
    },
  });
};
